import extractAttachmentSuggestions from './extractAttachmentSuggestions';
import { getMRUAttachmentStore } from 'owa-attachment-suggestions';
import ItemId from 'owa-service/lib/contract/ItemId';
import {
    AttachmentSuggestions,
    ClientItem,
    mailStore,
    ReplyWithAttachmentSuggestion,
} from 'owa-mail-store';

export default function getAttachMenuData(referenceItemId: ItemId) {
    // Get data about attachment suggestions shown.
    const referenceItem: ClientItem = mailStore.items.get(referenceItemId && referenceItemId.Id);
    const replyWithSuggestions: AttachmentSuggestions =
        referenceItem && referenceItem.AttachmentSuggestions;
    const contextualAttachmentSuggestions =
        referenceItem && referenceItem.ContextualAttachmentSuggestions;
    const mruSuggestions: ReplyWithAttachmentSuggestion[] = getMRUAttachmentStore().attachments;

    const attachmentSuggestions: ReplyWithAttachmentSuggestion[] = extractAttachmentSuggestions(
        replyWithSuggestions,
        [...(contextualAttachmentSuggestions || []), ...(mruSuggestions || [])]
    );

    const endpoints: number[] = [];
    const ids: string[] = [];
    const ranks: number[] = [];
    const provenances: string[] = [];
    const fileTypes: string[] = [];

    if (attachmentSuggestions) {
        attachmentSuggestions.forEach((item, index) => {
            endpoints.push(item.Endpoint);
            ids.push(item.Id);
            ranks.push(index);
            provenances.push(item.FileSourceType);
            fileTypes.push(item.FileExtension);
        });
    }

    return [
        endpoints.join(','),
        ids.join(','),
        ranks.join(','),
        provenances.join(','),
        fileTypes.join(','),
    ];
}
